import Vue from 'vue';
import store from '../../store.js';
import tabsData from '../../data/tabsData';

export function getAccess(values, route, needsEdit) {
    const user = store.getters.getUser;
    let hasAccess = false;

    // Convert to an array if values is not already an array
    if (!Array.isArray(values)) {
        values = [values];
    }

    for (const n of values) {
        const tab = tabsData[route].tabValues[n];

        if (!tab) continue;

        if (tab === true) {
            return 'edit'
        }

        if (user.roles && user.roles.length) {
            for (const role of user.roles) {
                if (role.access[tab]) {
                    if (needsEdit && role.access[tab] === 'edit') {
                        hasAccess = 'edit';
                        break;
                    } else if (!needsEdit && role.access[tab] !== 'none') {
                        hasAccess = role.access[tab];
                        break;
                    }
                }
            }
        }

        if (hasAccess) break;
    }

    if (!hasAccess && needsEdit) {
        if (Vue.prototype.$snotify) {
            Vue.prototype.$snotify.error('Нямате нужните права!');
        }
    }

    return hasAccess;
}